import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { City } from '../types/weather';

const LOCAL_STORAGE_KEY = 'weather_cities';

function loadCities(): City[] {
  try {
    const data = localStorage.getItem(LOCAL_STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

function saveCities(cities: City[]) {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(cities));
}

const initialState: City[] = loadCities();

const cityListSlice = createSlice({
  name: 'cityList',
  initialState,
  reducers: {
    addCity(state, action: PayloadAction<City>) {
      state.push(action.payload);
      saveCities(state);
    },
    removeCity(state, action: PayloadAction<string>) {
      const idx = state.findIndex(city => city.id === action.payload);
      if (idx !== -1) state.splice(idx, 1);
      saveCities(state);
    },
    setCities(state, action: PayloadAction<City[]>) {
      saveCities(action.payload);
      return action.payload;
    },
  },
});

export const { addCity, removeCity, setCities } = cityListSlice.actions;
export default cityListSlice.reducer; 